import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import SummaryApi from '../common'; 
import { useSelector } from 'react-redux';
import ROLE from '../common/role';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';


const PaymentOTPVerify = () => {
    const [otp, setOtp] = useState(['', '', '', '']);
    const [resending, setResending] = useState(false);
    const [resendCooldown, setResendCooldown] = useState(false); 
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false); 
    const user = useSelector(state => state?.user?.user);
 
    const {
        userId,
        deptQuantity,
        type,
        salesManId,
        salesManName,
        salesManEmail,
        salesManMobileNumber
    } = location.state || {};

    useEffect(() => {
        if (resendCooldown) {
            const timer = setTimeout(() => {
                setResendCooldown(false);
            }, 10000); // 10 seconds cooldown
            return () => clearTimeout(timer); // Clear timer on component unmount
        }
    }, [resendCooldown]);

    const handleChange = (e, index) => {
        const { value } = e.target;
        if (/^[0-9]?$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (value && index < otp.length - 1) {
                document.getElementById(`otp-input-${index + 1}`).focus();
            }
        }
    };

    const handlePaymentRequest = async () => {
       
      
        try {
          setLoading(true);
          const response = await fetch(SummaryApi.deptPaymentController.url, {
            method: SummaryApi.deptPaymentController.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              userId: userId,
              deptQuantity: deptQuantity,
              state: "accepted",
              type: type, 
              salesManId: salesManId,
              salesManName: salesManName,
              salesManEmail: salesManEmail,
              salesManMobileNumber:salesManMobileNumber,
              userMobileNumber:user?.mobileNumber,
              userName:user?.name,
              userShippingAddress:user?.shippingAddress,
              email:user?.email,
            }),
          });
      
          const result = await response.json();
      
          if (result.success) {
            toast.success('تم تقديم طلب سداد المديونية بنجاح');
          //  navigate('/');
          } else {
            toast.error(result.message || 'فشل طلب سداد المديونية');
          }
        } catch (error) {
          toast.error('فشل طلب سداد المديونية');
        } finally {
          setLoading(false);
        }
      };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const otpString = otp.join('');
        try {
            const response = await fetch(SummaryApi.deptVerifyOTP.url, {
                method: SummaryApi.deptVerifyOTP.method,
                headers: { "Content-Type": "application/json" },
                credentials: 'include',
                body: JSON.stringify({
                    userId: userId,
                    paymentOTP: otpString,
                    
                }),
            });

            const data = await response.json();
            if (data.success) {
                toast.success('تم التحقق من الرمز بنجاح');
                handlePaymentRequest();
                navigate('/');
            } else {
                toast.error(data.message);
                toast.error('رمز تحقق غير صحيح، يرجى المحاولة مرة أخرى');
            }
        } catch (error) {
            toast.error('حدث خطأ. يرجى المحاولة مرة أخرى');
        }
    };

    const handleResendOtp = async () => {
        if (resendCooldown) return; // Prevent resending if within cooldown period

        setResending(true);

        
        try {
            const response = await fetch(SummaryApi.deptRequestOTP.url, {
                method: SummaryApi.deptRequestOTP.method,
                headers: { "Content-Type": "application/json" },
                credentials: 'include',
                body: JSON.stringify({
                    userId: userId,
                    deptQuantity: deptQuantity,
                    salesManEmail: salesManEmail
                }),
            });

            const data = await response.json();
            if (data.success) {
                toast.success('تم إرسال رمز التحقق بنجاح');
                setResendCooldown(true); // Start cooldown period
            } else {
                toast.error(data.message);
                toast.error('حدث خطأ يرجي الذهاب لصفحة سداد المديونية لتحديد كمية و جهة الدفع');
            }
        } catch (error) {
            toast.error('حدث خطأ. يرجى المحاولة مرة أخرى');
        } finally {
            setResending(false); // Re-enable button after the request
        }
    };

    useEffect(() => {
        setLoading(true);
        const loadingTimeout = setTimeout(() => {
          setLoading(false);
          navigate("/");
        }, 10000); 
    
        if (user) {
          if (user?.role !== ROLE.GENERAL) {
            navigate("/");
            setLoading(false);
          } else {
            setLoading(false);
            clearTimeout(loadingTimeout);
          }
        } 
        
    
        return () => clearTimeout(loadingTimeout);
      }, [user, navigate]);

      if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
            </div>
        );
    }

    return (
        <section id='otp-page'>
            <div className='mx-auto container p-4'>
                <div className='bg-white p-5 w-full max-w-sm mx-auto'>
                    <form className='pt-6 flex flex-col gap-2' onSubmit={handleSubmit}>
                        <div className='flex justify-between'>
                            {otp.map((digit, index) => (
                                <input
                                    key={index}
                                    id={`otp-input-${index}`}
                                    type='text'
                                    maxLength='1'
                                    value={digit}
                                    onChange={(e) => handleChange(e, index)}
                                    className='w-12 h-12 text-center text-xl border border-gray-300 rounded'
                                />
                            ))}
                        </div>
                        <div className='flex justify-center'>
                            <button
                                type='submit'
                                className='flex items-center justify-center bg-blue-900 text-white px-4 py-2 text-sm rounded-full shadow-md hover:bg-blue-800 transition-colors duration-300 w-[120px] text-center'
                            >
                                 OTP تاكيد 
                            </button>
                        </div>
                        <div className='flex justify-center mt-4'>
                            <button
                                type='button'
                                onClick={handleResendOtp}
                                disabled={resending || resendCooldown} // Disable button during resend and cooldown
                                className='text-red-600 underline'
                            >
                                {resending ? 'إرسال الرمز...' : resendCooldown ? ' اعادة عملية الارسال خلال 10 ثوان ستكون متاحة' : 'لم يصل الرمز ؟ اعادة العملية من جديد'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default PaymentOTPVerify;
